import { render, staticRenderFns } from "./vIngredientsDisplayNames.vue?vue&type=template&id=cafd8dfc&scoped=true"
import script from "./vIngredientsDisplayNames.vue?vue&type=script&lang=ts"
export * from "./vIngredientsDisplayNames.vue?vue&type=script&lang=ts"
import style0 from "./vIngredientsDisplayNames.vue?vue&type=style&index=0&id=cafd8dfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cafd8dfc",
  null
  
)

export default component.exports